import { useState } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import Button from "../../../componentLibrary/Button";

export interface ToolboxManagementLayoutContext {
  setViewLearnerToolboxHandler: (handler: (() => void) | null) => void;
}

const ToolboxManagementLayout = () => {
  const { topicId } = useParams<{ topicId: string }>();
  const navigate = useNavigate();
  const [viewLearnerToolboxHandler, setViewLearnerToolboxHandler] = useState<
    (() => void) | null
  >(null);

  return (
    <div className="flex flex-col w-full mx-auto px-4 xl:px-16 py-6 min-h-screen">
      {topicId && (
        <div className="flex justify-end pb-3 mb-1 border-b border-gray-200">
          <Button
            type="button"
            variant="primary"
            size="sm"
            onClick={() =>
              viewLearnerToolboxHandler
                ? viewLearnerToolboxHandler()
                : navigate(`/toolboxes/${topicId}`)
            }
          >
            View learner toolbox
          </Button>
        </div>
      )}
      <Outlet context={{ setViewLearnerToolboxHandler }} />
    </div>
  );
};

export default ToolboxManagementLayout;
